module.exports = __webpack_public_path__ + "static/media/livelike.94f22aeb.png";